"use strict"

angular.module("customer")
.service("CustomerPaymentSettingsService", function($http, appConfig) {
    this.getPreAuthorizedPaymentAgreements = function() {
        return $http.get(appConfig.API_SERVER + "/payment-methods/customer/pre-authorized-payment-agreements/");
    };

    this.getPreAuthorizedPaymentTerms = function(partnershipId) {
        return $http.get(appConfig.API_SERVER + "/payment-methods/customer/partnership-payment-methods-terms/" + partnershipId + "/");
    };

    this.acceptPreAuthorizedPaymentTerms = function(partnershipId, selectedPaymentMethod, selectedAccount) {
        return $http.post(
            appConfig.API_SERVER + "/payment-methods/customer/partnership-payment-methods-terms/" + partnershipId + "/",
            {
                selected_payment_method: selectedPaymentMethod,
                selected_account: selectedAccount
            }
        );
    };
});



//////////////////
// WEBPACK FOOTER
// ./customer/sections/payment-settings/payment-settings.service.js
// module id = 966
// module chunks = 0